<template>
    <div class="wechat">
        <div class="top-box">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>小程序管理</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="tab-list d_flex a_c ">
                <h2>小程序设置</h2>
            </div>
        </div>
        <div class="page-content">
            <div class="box bg_fff p20">
                <el-tabs v-model="activeName">
                    <el-tab-pane label="banner设置" name="0">
                        <div class="banner">
                            <el-button type="primary" @click="bannerPop=true">新增轮播图</el-button>
                            <div class="table-box">
                                <el-table
                                        :data="banner.bannerList"
                                        border
                                        style="width: 100%">
                                    <el-table-column
                                            prop="city_id"
                                            label="城市"
                                            align="center"
                                            width="180">
                                        <template slot-scope="scope">
                                            {{scope.row.city_id|handleCity(that)}}
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                            label="图片"
                                            align="center"
                                            >
                                        <template slot-scope="scope">
                                            <img :src="baseUrl+scope.row.path" alt="" style="width: 100px;height: 40px;">
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                            prop="addtime"
                                            align="center"
                                            label="添加时间">
                                    </el-table-column>
                                    <el-table-column  label="操作" align="center" width="180px" >
                                        <template slot-scope="scope">
                                            <el-button type="text" size="small" @click="delBanner(scope.row)">删除</el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                                <el-pagination
                                        background
                                        layout="prev, pager, next"
                                        :total="banner.pages"
                                        :current-page="banner.page"
                                        @current-change="handleBanner"
                                        style="margin-top: 20px; text-align: right;"
                                >
                                </el-pagination>
                            </div>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="广告图设置" name="1">
                        <div class="banner">
                            <div class="item d_flex">
                                <el-button type="primary" @click="avPop=true">新增广告图</el-button>
                            </div>
                            <div class="table-box">
                                <el-table
                                        :data="poster.bannerList"
                                        border
                                        style="width: 100%">
                                    <el-table-column
                                            prop="city_id"
                                            label="城市"
                                            align="center"
                                            width="180">
                                        <template slot-scope="scope">
                                            {{scope.row.city_id|handleCity(that)}}
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                            label="图片"
                                            align="center"
                                    >
                                        <template slot-scope="scope">
                                            <img :src="baseUrl+scope.row.path" alt="" style="width: 100px;height: 30px;">
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                            prop="addtime"
                                            align="center"
                                            label="添加时间">
                                    </el-table-column>
                                    <el-table-column  label="操作" align="center" width="180px" >
                                        <template slot-scope="scope">
                                            <el-button type="text" size="small" @click="delBanner(scope.row)">删除</el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                                <el-pagination
                                        background
                                        layout="prev, pager, next"
                                        :total="poster.pages"
                                        :current-page="poster.page"
                                        @current-change="handleAv"
                                        style="margin-top: 20px; text-align: right;"
                                >
                                </el-pagination>
                            </div>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="公告设置" name="2">
                        <div class="banner">
                            <el-button type="primary" @click="articlePop=true">新增公告</el-button>
                            <div class="table-box">
                                <el-table
                                        :data="article.list"
                                        border
                                        style="width: 100%">
                                    <el-table-column
                                            prop="title"
                                            label="公告标题"
                                            align="center"
                                            width="180">
                                    </el-table-column>
                                    <el-table-column
                                            prop="addtime"
                                            align="center"
                                            label="添加时间">
                                    </el-table-column>
                                    <el-table-column  label="操作" align="center" width="180px" >
                                        <template slot-scope="scope">
                                            <el-button type="text" size="small" @click="delArticle(scope.row)">删除</el-button>
                                            <el-button type="text" size="small" @click="articleInfo(scope.row)">查看详情</el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                                <el-pagination
                                        background
                                        layout="prev, pager, next"
                                        :total="article.pages"
                                        :current-page="article.page"
                                        @current-change="handleArtcile"
                                        style="margin-top: 20px; text-align: right;"
                                >
                                </el-pagination>
                            </div>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>
        <el-dialog :visible.sync="bannerPop"   width="500px">
            <div class="banner-add">
                <div class="title" style="font-size: 20px;text-align: center;font-weight: bold;margin-bottom: 20px;">添加轮播图</div>
                <div class="tip" style="font-size: 14px;margin: 10px 0;text-align: center;color: #999;">图片尺寸为<span class="col_red">750*300</span></div>
                <el-form ref="form" :model="bannerform" label-width="80px" style="text-align: left">
                    <el-form-item label="城市名称" v-if="userinfo&&userinfo.user_type==1">
                        <el-select v-model="bannerform.city_id" clearable  filterable placeholder="输入城市关键字"  style="width: 250px;">
                            <el-option
                                    v-for="item in cityList"
                                    :key="item.city_id"
                                    :label="item.name"
                                    :value="item.city_id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="轮播图">
                        <el-upload class="avatar-uploader"
                                   ref="otherLicense"
                                   :auto-upload="false"
                                   action
                                   :multiple="true"
                                   :on-preview="handlePicPreview"
                                   :on-remove="handleRemove"
                                   :file-list="bannerform.bannerImg"
                                   :on-change="otherSectionFile"
                                   :limit="1"
                                   list-type="picture-card"
                        >
                            <i class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                    </el-form-item>
                    <div class="btn-box" style="margin-top: 20px;">
                        <el-button @click="closePop">取消</el-button>
                        <el-button type="primary" @click="addBanner">确定</el-button>
                    </div>
                </el-form>
            </div>
        </el-dialog>

        <el-dialog :visible.sync="avPop"   width="500px">
            <div class="banner-add">
                <div class="title" style="font-size: 20px;text-align: center;font-weight: bold;margin-bottom: 20px;">添加广告图</div>
                <div class="tip" style="font-size: 14px;margin: 10px 0;text-align: center;color: #999;">图片尺寸为<span class="col_red">700*200</span></div>
                <el-form ref="form" :model="avform" label-width="80px" style="text-align: left">
                    <el-form-item label="城市名称" v-if="userinfo&&userinfo.user_type==1">
                        <el-select v-model="avform.city_id" clearable  filterable placeholder="输入城市关键字"  style="width: 250px;">
                            <el-option
                                    v-for="item in cityList"
                                    :key="item.city_id"
                                    :label="item.name"
                                    :value="item.city_id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="广告图">
                        <el-upload class="avatar-uploader"
                                   ref="otherLicense"
                                   :auto-upload="false"
                                   action
                                   :multiple="true"
                                   :on-preview="handlePicPreview1"
                                   :on-remove="handleRemove1"
                                   :file-list="avform.bannerImg"
                                   :on-change="otherSectionFile1"
                                   :limit="1"
                                   list-type="picture-card"
                        >
                            <i class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                    </el-form-item>
                    <div class="btn-box" style="margin-top: 20px;">
                        <el-button @click="closeAvPop">取消</el-button>
                        <el-button type="primary" @click="addAv">确定</el-button>
                    </div>
                </el-form>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="articlePop"   width="800px">
            <div class="article-box">
                <div class="tit"  style="font-size: 20px;text-align: center;font-weight: bold;margin-bottom: 20px;">添加公告</div>
                <el-form ref="form" :model="form" label-width="80px" style="text-align: left">
                    <el-form-item label="城市名称" v-if="userinfo&&userinfo.user_type==1">
                        <el-select v-model="articleform.city_id" clearable  filterable placeholder="输入城市关键字"  style="width: 250px;">
                            <el-option
                                    v-for="item in cityList"
                                    :key="item.city_id"
                                    :label="item.name"
                                    :value="item.city_id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="公告标题">
                        <el-input v-model="articleform.title" placeholder="输入公告标题"></el-input>
                    </el-form-item>
                    <el-form-item label="公告内容">
                        <quill-editor ref="text" v-model="articleform.content" class="myQuillEditor" :options="editorOption" />
                    </el-form-item>
                </el-form>
                <div class="btn-box" style="margin-top: 20px;text-align: left;margin-left: 20px;">
                    <el-button @click="closeArticlePop">取消</el-button>
                    <el-button type="primary" @click="addArticle">确定</el-button>
                </div>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
        <el-dialog :visible.sync="infoPop">
            <div class="article-info">
                <div class="title" style="font-size: 20px;text-align: center;margin-bottom: 30px;font-weight: bold;">{{curArticle.title}}</div>
                <p v-html="curArticle.content" style="text-align: left"></p>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import { quillEditor } from 'vue-quill-editor'
    import 'quill/dist/quill.core.css'
    import 'quill/dist/quill.snow.css'
    import 'quill/dist/quill.bubble.css'
    import {searchCity} from '../../api/city'
    import {bannerList,avList,articleList,setBanner,delBanner,saveAv,saveArticle,delArticle} from '../../api/wechat'
    import { mapState } from 'vuex';
    var city_list=[];
    export default {
        name: "wechat",
        components: {
            quillEditor
        },
        data(){
            return{
                activeName: 0,
                bannerPop:false,
                avPop:false,
                articlePop:false,
                dialogVisible:false,
                infoPop:false,
                dialogImageUrl:'',
                form:{
                    banner:'',
                    article:'',
                    poster:'',
                },
                content: '',
                editorOption: {
                    theme: 'snow',
                    modules: {
                        toolbar: [
                            ['bold', 'italic', 'underline', 'strike'],
                            ['blockquote', 'code-block'],
                            [{ 'header': 1 }, { 'header': 2 }],
                            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                            [{ 'script': 'sub' }, { 'script': 'super' }],
                            [{ 'indent': '-1' }, { 'indent': '+1' }],
                            [{ 'direction': 'rtl' }],
                            [{ 'size': ['small', false, 'large', 'huge'] }],
                            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                            [{ 'color': [] }, { 'background': [] }],
                            [{ 'font': [] }],
                            [{ 'align': [] }],
                            ['clean'],
                            ['link', 'image']
                        ]
                    },
                    placeholder: '请输入文章内容',
                    readOnly: false
                },
                banner:{
                    bannerList:[],
                    page:1,
                    pages:1
                },
                poster:{
                    bannerList:[],
                    page:1,
                    pages:1
                },
                article:{
                    list:[],
                    page:1,
                    pages:1
                },
                bannerform:{
                    city_id:'',
                    bannerImg:[],
                },
                avform:{
                    city_id:'',
                    bannerImg:[],
                },
                articleform:{
                    title:'',
                    content:'',
                    city_id:''
                },
                city_id:'',
                cityList:[],
                curArticle:'',
                that: this,
                userinfo:'',
            }
        },
        computed:{
            ...mapState(['baseUrl'])
        },
        mounted(){

            this.userinfo=JSON.parse(localStorage.getItem('USERINFO'));
            if(this.userinfo.user_type!=1){
                this.bannerform.city_id= this.userinfo.city_id
                this.avform.city_id= this.userinfo.city_id
                this.articleform.city_id= this.userinfo.city_id
                this.city_id= this.userinfo.city_id
            }
            this.bannerList();
            this.avList();
            this.articleList();
            this.searchCity();
        },
        filters:{
            handleCity(city_id,that){
                let str='';
                if(city_id==''){
                    str='默认'
                }else{
                    that.cityList.map(val=>{
                        if(val.city_id==city_id){
                            str=val.name
                        }
                    })
                }
                return str;
            }
        },
        methods: {
            bannerList(){
                bannerList({
                    page:this.banner.page,
                    cate_id:1,
                    city_id:this.city_id
                }).then(res=>{
                    if(res.code==1){
                        this.banner.bannerList=res.data.list;
                        this.banner.pages=res.data.total_num;
                    }
                })
            },
            avList(){
                bannerList({page:this.poster.page,cate_id:2,city_id:this.city_id}).then(res=>{
                    if(res.code==1){
                        this.poster.bannerList=res.data.list;
                        this.poster.pages=res.data.total_num;
                    }
                })
            },
            articleList(){
                articleList( { page:this.article.page,city_id:this.city_id}).then(res=>{
                    if(res.code==1){
                        this.article.list=res.data.list;
                        this.article.pages=res.data.total_num
                    }
                })
            },
            //获取震城市列表
            searchCity(){
                searchCity({level:2}).then(res=>{
                    if(res.code==1){
                        this.cityList=res.data;
                        city_list=res.data;
                    }
                })
            },
            //图片上传处理
            handlePicPreview(file){
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            handleRemove(file) {
                this.bannerform.bannerImg.map((item,index)=>{
                    if(item.uid==file.uid){
                        this.bannerform.bannerImg.splice(index,1)
                    }
                })
            },
            otherSectionFile(file){
                console.log(file)
                const typeArr = ['image/png', 'image/gif', 'image/jpeg', 'image/jpg'];
                const isJPG = typeArr.indexOf(file.raw.type) !== -1;
                const isLt3M = file.size / 1024 / 1024 < 3;
                if (!isJPG) {
                    this.$message.error('只能是图片!');
                    this.$refs.upload.clearFiles();
                    this.otherFiles = null;
                    return;
                }
                if (!isLt3M) {
                    this.$message.error('上传图片大小不能超过 3MB!');
                    this.$refs.upload.clearFiles();
                    this.otherFiles = null;
                    return;
                }
                this.otherFiles = file.raw;
                // FormData 对象
                var formData = new FormData();
                // 文件对象
                formData.append('image', this.otherFiles);
                formData.append('type', 'service');
                formData.append('is_cover', 0);
                let config = {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'token':localStorage.getItem('UTOKEN')
                    }
                }
                let baseURL= process.env.NODE_ENV==='development'?'/api/':'https://cdb.0731app.cn/';
                this.$axios.post(baseURL+"home/upload/image",formData,config).then(res=>{
                    console.log(res);
                    if(res.data.code==1){
                        this.bannerform.bannerImg.push(res.data.data.path);
                    }
                })
            },
            handlePicPreview1(file){
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            handleRemove1(file) {
                this.avform.bannerImg.map((item,index)=>{
                    if(item.uid==file.uid){
                        this.avform.bannerImg.splice(index,1)
                    }
                })
            },
            otherSectionFile1(file){
                console.log(file)
                const typeArr = ['image/png', 'image/gif', 'image/jpeg', 'image/jpg'];
                const isJPG = typeArr.indexOf(file.raw.type) !== -1;
                const isLt3M = file.size / 1024 / 1024 < 30;
                if (!isJPG) {
                    this.$message.error('只能是图片!');
                    this.$refs.upload.clearFiles();
                    this.otherFiles = null;
                    return;
                }
                if (!isLt3M) {
                    this.$message.error('上传图片大小不能超过 30MB!');
                    this.$refs.upload.clearFiles();
                    this.otherFiles = null;
                    return;
                }
                this.otherFiles = file.raw;
                // FormData 对象
                var formData = new FormData();
                // 文件对象
                formData.append('image', this.otherFiles);
                formData.append('type', 'service');
                formData.append('is_cover', 0);
                let config = {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'token':localStorage.getItem('UTOKEN')
                    }
                }
                let baseURL= process.env.NODE_ENV==='development'?'/api/':'https://cdb.0731app.cn/';
                this.$axios.post(baseURL+"home/upload/image",formData,config).then(res=>{
                    console.log(res);
                    if(res.data.code==1){
                        this.avform.bannerImg.push(res.data.data.path);
                    }
                })
            },
            closePop(){
              this.bannerform.bannerImg=[];
              this.bannerPop=false;
            },
            closeAvPop(){
                this.avform.bannerImg=[];
                this.avPop=false;
            },
            closeArticlePop(){
                this.articleform={
                    title:'',
                    content:'',
                    city_id:''
                }
                this.articlePop=false;
            },
            addBanner(){
                setBanner({
                    city_id:this.bannerform.city_id,
                    path:this.bannerform.bannerImg.join(',')
                }).then(res=>{
                    if(res.code==1){
                        this.$message.success('设置成功');
                        this.bannerPop=false;
                        this.bannerList();
                    }
                })
            },
            addAv(){
                saveAv({
                    path:this.avform.bannerImg.join(','),
                    city_id:this.avform.city_id,
                }).then(res=>{
                    if(res.code==1){
                        this.$message.success('设置成功');
                        this.avPop=false;
                        this.avList();
                    }
                })
            },
            addArticle(){
                saveArticle(this.articleform).then(res=>{
                    if(res.code==1){
                        this.$message.success('设置成功');
                        this.articlePop=false;
                        this.articleList();
                    }
                })
            },
            articleInfo(row){
                this.curArticle=row;
                this.infoPop=true;
            },
            delBanner(row){
                this.$confirm('此操作将永久删除该轮播图, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    delBanner({banner_id:row.banner_id}).then(res=>{
                        if(res.code==1){
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                            this.bannerList();
                        }
                    })
                })
            },
            delArticle(row){
                this.$confirm('此操作将永久删除该公告, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    delArticle({aid:row.aid}).then(res=>{
                        if(res.code==1){
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                            this.articleList();
                        }
                    })
                })
            },
            // 页码
            handleBanner(val){
                this.page = val;
                this.bannerList();
            },
            handleAv(val){
                this.page = val;
                this.bannerList();
            },
            handleArtcile(val){
                this.page = val;
                this.bannerList();
            },

        }
    }
</script>

<style lang="scss" scoped>
    .top-box {
        width: 100%;
        height: 100px;
        background-color: #ffffff;
        padding: 20px;

        .tab-list {
            margin-top: 20px;

            h2 {
                margin-right: 20px;
                padding-right: 20px;
                border-right: 1px solid #eaeaea;
            }

            .item {
                font-size: 16px;
                color: #409EFF;
                display: flex;
                align-items: center;
                cursor: pointer;

                .icon {
                    font-size: 20px;
                    color: #409EFF;
                    margin-right: 5px;
                }
            }
        }
    }
    .page-content{
        padding: 20px;
        .form-box{
            background-color: #fff;
            padding: 20px;
        }
        .box{
            width: 100%;
        }
        .banner{
            text-align:left;
        }
        .table-box{
            margin-top: 20px;
        }
    }
</style>
